export { default as ProductPageHeader } from './ProductPageHeader';
export { default as productsPageHeaderAdapter } from './adapters';
